<template>
  <div class="sub-routes">
    <section class="app-section"
             id="questionnaire_form">
      <div class="questionnaire-form">
        <!-- 列表的表单 -->
        <el-card class="box-card">
          <div class="quest-titles">
            <el-button type="primary"
                       round
                       class="creatBtn"
                       @click="creatquestionaire"
                       style="background: #4286f1;">创建随访类型</el-button>
          </div>
          <div class="table-container">

            <el-table border
                      body="true"
                      v-loading="loading"
                      :data="quesList"
                      :default-sort="{ prop: 'date', order: 'ascending' }"
                      style="width: 100%;font-size: 14px">
              <el-table-column align='center'
                               prop="date"
                               label="随访类型名称">
                <template slot-scope="scope">
                  <div>{{ scope.row.follow_name }}</div>
                </template>
              </el-table-column>

              <el-table-column align='center'
                               prop="date"
                               label="创建时间">
                <template slot-scope="scope">
                  <div>{{ scope.row.created_time }}</div>
                </template>
              </el-table-column>

              <el-table-column align='center'
                               prop="operation"
                               label="操作">
                <template slot-scope="scope">
                  <el-button type="text"
                             size="medium"
                             @click.stop="changeStatus(scope.row)"
                             style="color: #4286f1;">编辑</el-button>

                  <el-button type="text"
                             size="medium"
                             style="color:#fa7070"
                             @click.stop="deleQues(scope.row.follow_code)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div style="text-align: right;margin: 30px 0 0 0;"
                 v-show="quesList.length != 0">
              <div class="block"></div>
            </div>
          </div>
        </el-card>
      </div>
    </section>
    <Modal v-model="dialogFormVisible"
           draggable
           footer-hide
           :title="title"
           :z-index="999">
      <div :style="{'max-height': (windowHeight - 100 * 2 - 150) + 'px'}"
           style="overflow-y:auto;">
        <Form ref="form"
              :model="form"
              :rules="formRules"
              :label-width="100">
          <FormItem label="随访类型名称"
                    prop="type_name">
            <Input v-model="form.follow_name"
                   placeholder="请输入请输入随访类型名称"></Input>
          </FormItem>
        </Form>
        <div style="text-align:center;margin-top:16px;">
          <Button @click="dialogFormVisible = false">取 消</Button>
          <Button type="primary"
                  style="margin-left:20px"
                  @click="editName()">确 定</Button>
        </div>
      </div>
    </Modal>

  </div>
</template>
<script>
import { Message, MessageBox } from 'element-ui'
export default {
  name: 'questionnaireList',
  data() {
    return {
      title: '',
      editBtn: false,
      deleteBtn: false,
      quesList: [],
      total: 0,
      currentPage: 1,
      page: 1,
      size: 10,
      loading: false,
      length: '',
      dialogFormVisible: false,
      formRules: {
        type_name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
        ],
        // name: [{ required: true, message: '请选择分类名称', trigger: 'blur' }],
      },
      form: {
        follow_name: '',
        follow_code: '',
      },
      formLabelWidth: '120px',
    }
  },
  computed: {
    //     refreshQues: function () {
    //       return this.$store.state.refreshQues
    //     },
    windowHeight: function () {
      return window.innerHeight
    },
  },
  watch: {
    routerName(val) {
      if (val == 'questionnaireList') {
        console.log('val', val)
        this.quesList = []
      }
    },
  },
  methods: {
    creatquestionaire() {
      this.dialogFormVisible = !this.dialogFormVisible
      this.form.follow_name = ''
      this.form.follow_code = ''
      this.title = '创建随访类型名称'
    },

    //删除问卷
    deleQues(id) {
      MessageBox.confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$utils.caringRequest({
          method: 'delete',
          url: this.$utils.getInterface('DELETEFOLLOW') + id,
          success: (res) => {
            if (res.code == 0) {
              console.log(res)
              Message({
                type: 'success',
                message: '删除成功',
              })
              this.getFollowList()
            } else {
              Message({
                type: 'warning',
                message: res.data.message,
              })
            }
          },
        })
      })
    },
    editName() {
      if (this.form.follow_code) {
        this.$utils.caringRequest({
          method: 'patch',
          url: this.$utils.getInterface('PATCHFOLLOW_TYPE'),
          data: this.form,
          success: (res) => {
            console.log(res)
            if (res.code == 0) {
              Message({
                type: 'success',
                message: '修改成功',
              })
              this.dialogFormVisible = !this.dialogFormVisible
              this.getFollowList()
            } else {
              Message({
                type: 'warning',
                message: res.data.message,
              })
            }
          },
        })
      } else {
        this.$utils.caringRequest({
          method: 'post',
          url: this.$utils.getInterface('PATCHFOLLOW_TYPE'),
          data: {
            follow_name: this.form.follow_name,
          },
          success: (res) => {
            console.log(res)
            if (res.code == 0) {
              Message({
                type: 'success',
                message: '创建成功',
              })
              this.dialogFormVisible = !this.dialogFormVisible
              this.getFollowList()
            } else {
              Message({
                type: 'warning',
                message: res.data.message,
              })
            }
          },
        })
      }
    },
    changeStatus(val) {
      this.dialogFormVisible = !this.dialogFormVisible
      this.form.follow_name = val.follow_name
      this.form.follow_code = val.follow_code
      this.title = '编辑随访类型名称'
    },
    compare(realIndex) {
      return function (obj1, obj2) {
        var value1 = obj1[realIndex]
        var value2 = obj2[realIndex]
        return value1 - value2
      }
    },
    getFollowList() {
      if (!this.quesList.length) {
        this.loading = true
      }

      this.$utils.caringRequest({
        method: 'get',
        url: this.$utils.getInterface('FOLLOW_TYPE'),

        success: (res) => {
          this.loading = false

          this.quesList = res.data
          this.length = this.quesList.length
        },
      })
    },
  },
  mounted() {
    this.getFollowList()
  },

  components: {},
}
</script>
<style lang="less" scoped>
.v-modal {
  width: 0 !important;
}
.sub-routes {
  height: 100%;
  position: relative;
  background: #f8f8f9;
  /* min-width: 1200px; */
  overflow-x: auto;
}
.el-dialog__body {
  padding: 10px 20px;
}
.quest-titles {
  margin-bottom: 15px;

  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(116, 130, 154, 1);
  /* padding-left: 30px; */
}
.creatBtn {
  /* position: absolute;
  right: 3%;
  top: 10px; */
  padding: 8px 20px;
  background-color: #4286f1;
  font-size: 12px;
}
#questionnaire_form {
  /* background-color: #f5f7fa; */
  color: #566277;
  /* background-color: rgb(240, 243, 250); */
}
/* 问卷列表标题 */
#questionnaire_form .questionnaire-form .quest-title {
  font-size: 14px;
  position: absolute;
  text-align: right;
  right: 0;
}
#questionnaire_form .quest-title .el-button {
  /* position: absolute; */
  right: 2%;
  top: 14px;
  padding: 10px 25px;
  background-color: #4286f1;
  font-size: 12px;
}

#questionnaire_form .table-container {
  /* width: 94%; */
  /* margin: auto;
  padding: 0 15px;
  height: 85%; */
}
#questionnaire_form .has-gutter tr th {
  background-color: #e2e8f3;
  text-align: center;
}
#questionnaire_form tr td {
  border-bottom: none;
  text-align: center;
}
#questionnaire_form .el-table {
  height: 75%;
  overflow-y: auto;
}
#questionnaire_form .el-table::before {
  height: 0;
}
#questionnaire_form
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td {
  background-color: #f6f8fc;
}
#questionnaire_form .el-table td,
.el-table th {
  padding: 10px 0;
}
#questionnaire_form .green-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #40c68f;
  display: inline-block;
}
#questionnaire_form .el-table__row:hover {
  cursor: pointer;
}
#questionnaire_form .el-table td,
.el-table th {
  text-align: center;
}
</style>